module.exports = __webpack_public_path__ + "static/media/favorite_black.d9a28597.svg";